import { HAIR } from './settings/hair';
import { FACE } from './settings/face';
import { SHIRT } from './settings/shirt';
import { PANTS } from './settings/pants';
import { OPTIONS } from '@/utils/common';
import SkinAvatar from './Options/SkinAvatar';
import ColorAvatar from './Options/ColorAvatar';
import DetailsAvatar from './Options/DetailsAvatar';
import AccessoriesAvatar from './Options/AccessoriesAvatar';
import IconFace from '@/assets/images/icons/icon-face.svg?component';
import IconWear from '@/assets/images/icons/icon-wear.svg?component';
import type { IAvatarOptions, ITabOption, ISetOption } from './types';
import IconFrame from '@/assets/images/icons/icon-frame.svg?component';
import IconPerson from '@/assets/images/icons/icon-person.svg?component';
import IconGlasses from '@/assets/images/icons/icon-glasses.svg?component';
import IconTrousers from '@/assets/images/icons/icon-trousers.svg?component';
import IconScissors from '@/assets/images/icons/icons-scissors.svg?component';

type ITabProps = {
  toggleColorPanel: (visible: boolean) => void;
  translations: Record<string, string>;
  setFocus?: (focus: boolean) => void;
  options: IAvatarOptions;
  setOption: ISetOption;
};

export const GET_TAB_OPTIONS = ({
  toggleColorPanel,
  translations,
  setOption,
  setFocus,
  options
}: ITabProps): ITabOption[] => {
  return [
    {
      icon: <IconPerson />,
      value: OPTIONS.details,
      label: translations.person_label,
      component: <DetailsAvatar
        translations={translations}
        setOption={setOption}
        setFocus={setFocus}
        options={options}
      />
    },
    {
      icon: <IconFace />,
      value: OPTIONS.skinColor,
      label: translations.facial_label,
      component: (
        <SkinAvatar
          label={translations.facial_select_colour}
          option={options[OPTIONS.skinColor]}
          translations={translations}
          name={OPTIONS.skinColor}
          setOption={setOption}
        />
      )
    },
    {
      value: OPTIONS.hair,
      icon: <IconScissors />,
      label: translations.haircut_label,
      component: (
        <AccessoriesAvatar
          label={translations.haircolour_select_colour}
          colorTitle={translations.haircut_colour}
          toggleColorPanel={toggleColorPanel}
          option={options[OPTIONS.elements]}
          translations={translations}
          setOption={setOption}
          name={OPTIONS.hair}
          keysItem="hair"
          list={HAIR}
        />
      )
    },
    {
      value: OPTIONS.face,
      icon: <IconGlasses />,
      label: translations.kader_label,
      component: (
        <AccessoriesAvatar
          colorTitle="Colore delle sopracciglia"
          label={translations.kader_select_colour}
          toggleColorPanel={toggleColorPanel}
          option={options[OPTIONS.elements]}
          translations={translations}
          setOption={setOption}
          name={OPTIONS.face}
          keysItem="face"
          list={FACE}
        />
      )
    },
    {
      icon: <IconWear />,
      value: OPTIONS.shirt,
      label: translations.top_label,
      component: (
        <AccessoriesAvatar
          label={translations.top_select_colour}
          colorTitle={translations.top_colour}
          toggleColorPanel={toggleColorPanel}
          option={options[OPTIONS.elements]}
          translations={translations}
          setOption={setOption}
          name={OPTIONS.shirt}
          keysItem="shirt"
          list={SHIRT}
        />
      )
    },
    {
      value: OPTIONS.pants,
      icon: <IconTrousers />,
      label: translations.bottom_label,
      component: (
        <AccessoriesAvatar
          label={translations.bottom_select_colour}
          colorTitle={translations.bottom_colour}
          toggleColorPanel={toggleColorPanel}
          option={options[OPTIONS.elements]}
          translations={translations}
          setOption={setOption}
          name={OPTIONS.pants}
          keysItem="pants"
          list={PANTS}
        />
      )
    },
    {
      icon: <IconFrame />,
      value: OPTIONS.favoriteColor,
      label: translations.colour_label,
      component: (
        <ColorAvatar
          option={options[OPTIONS.favoriteColor]}
          name={OPTIONS.favoriteColor}
          translations={translations}
          setOption={setOption}
        />
      )
    }
  ];
};
